<template>
  <vx-card no-shadow>
    <vs-popup
      fullscreen
      :title="popupTitle"
      :active.sync="popupActive"
      v-if="currentTemplate != null"
    >
      <b>Details</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="label"
            label-placeholder="Label"
            v-model="currentTemplate.label"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            name="remarks"
            label-placeholder="Remarks"
            v-model="currentTemplate.remarks"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            name="type"
            disabled="true"
            label-placeholder="Type"
            v-model="currentTemplate.type"
            class="w-full"
          />
        </div>
        <br />
      </div>
      <hr />
      <br />

      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Parameters</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="alterParameter('add')"
            >Add Parameter</vs-button
          >
        </div>
      </div>
      <br />

      <div v-for="(item, index) in currentTemplate.parameters" :key="index">
        <div class="vx-row" v-if="item.relation != null">
          <br />
          <div class="vx-col md:w-1/3 w-half">
            <b>Operand</b>
          </div>
          <div class="vx-col md:w-1/3 w-half">
            <ejs-multiselect
              id="multiselect"
              :fields="parameterFieldsRelations"
              v-model="item.relation"
              maximumSelectionLength="1"
              :dataSource="parameterOptionsRelations"
              showClearButton="false"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="false"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="false"
              placeholder="Select Operand"
            ></ejs-multiselect>
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-half">
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-half">
                Parameter {{ index + 1 }}.
              </div>
              <div class="vx-col md:w-2/3 w-full">
                <ejs-multiselect
                  id="multiselect"
                  :fields="parameterFields"
                  v-model="item.idx"
                  maximumSelectionLength="1"
                  :dataSource="parameterOptions"
                  showClearButton="false"
                  popupHeight="400px"
                  mode="CheckBox"
                  enableGroupCheckBox="false"
                  showDropDownIcon="true"
                  allowFiltering="true"
                  filterType="contains"
                  filterBarPlaceholder="Search"
                  showSelectAll="false"
                  placeholder="Select Parameter"
                ></ejs-multiselect>
              </div>
            </div>
          </div>

          <div
            class="vx-col md:w-1/3 w-half"
            v-if="
              item.idx != null &&
              item.idx[0] != null &&
              parameterOptions[item.idx[0]].parameterGroup == 'Boolean'
            "
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-half">
                <ejs-multiselect
                  showSelectAll="false"
                  id="multiselect2"
                  :fields="parameterFieldsBoolean"
                  v-model="item.value"
                  :dataSource="parameterOptions[item.idx[0]].opts"
                  popupHeight="400px"
                  mode="CheckBox"
                  showClearButton="false"
                  enableGroupCheckBox="false"
                  showDropDownIcon="true"
                  maximumSelectionLength="1"
                  allowFiltering="true"
                  filterType="contains"
                  filterBarPlaceholder="Search"
                  placeholder="Select Value"
                ></ejs-multiselect>
              </div>
              <div class="vx-col md:w-1/2 w-half">
                <vs-button
                  color="danger"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="alterParameter('remove', index)"
                  >Remove Parameter</vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="vx-col md:w-2/3 w-half"
            v-if="
              item.idx != null &&
              item.idx[0] != null &&
              parameterOptions[item.idx[0]].parameterGroup == 'Variable'
            "
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-half">
                <ejs-multiselect
                  showSelectAll="false"
                  id="multiselect3"
                  :fields="parameterFieldsBoolean"
                  v-model="item.value"
                  :dataSource="parameterOptions[item.idx[0]].opts"
                  popupHeight="400px"
                  mode="CheckBox"
                  showClearButton="false"
                  enableGroupCheckBox="false"
                  showDropDownIcon="true"
                  maximumSelectionLength="1"
                  allowFiltering="true"
                  filterType="contains"
                  filterBarPlaceholder="Search"
                  placeholder="Select Inequality Expression"
                ></ejs-multiselect>
              </div>
              <div class="vx-col md:w-1/3 w-half">
                <vs-input
                  name="value2"
                  :label-placeholder="
                    'Enter Value - in ' +
                    parameterOptions[item.idx[0]].parameterPostFix
                  "
                  v-model="item.value2"
                  class="w-full"
                />
              </div>
              <div class="vx-col md:w-1/3 w-half">
                <vs-button
                  color="danger"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="alterParameter('remove', index)"
                  >Remove Parameter</vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="vx-col md:w-2/3 w-half"
            v-if="
              item.idx != null &&
              item.idx[0] != null &&
              parameterOptions[item.idx[0]].parameterGroup == 'Location'
            "
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-half">
                <ejs-multiselect
                  showSelectAll="false"
                  id="multiselect4"
                  :fields="parameterFieldsLocation"
                  v-model="item.value"
                  :dataSource="parameterOptions[item.idx[0]].opts"
                  popupHeight="400px"
                  mode="CheckBox"
                  showClearButton="false"
                  enableGroupCheckBox="false"
                  showDropDownIcon="true"
                  allowFiltering="true"
                  filterType="contains"
                  filterBarPlaceholder="Search"
                  placeholder="Select Movement Type"
                ></ejs-multiselect>
              </div>
              <div class="vx-col md:w-1/3 w-half">
                <ejs-multiselect
                  showSelectAll="false"
                  id="multiselect5"
                  :fields="parameterFieldsPOI"
                  v-model="item.value2"
                  :dataSource="mapPOIData"
                  popupHeight="400px"
                  mode="CheckBox"
                  showClearButton="false"
                  enableGroupCheckBox="false"
                  showDropDownIcon="true"
                  allowFiltering="true"
                  filterType="contains"
                  filterBarPlaceholder="Search"
                  placeholder="Select Place of Interest"
                ></ejs-multiselect>
              </div>
              <div class="vx-col md:w-1/3 w-half">
                <vs-button
                  color="danger"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="alterParameter('remove', index)"
                  >Remove Parameter</vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="vx-col md:w-1/3 w-half"
            v-if="
              item.idx != null &&
              item.idx[0] != null &&
              parameterOptions[item.idx[0]].parameterGroup == 'Elapsed Time'
            "
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-half">
                <vs-input
                  label-placeholder="Enter Value"
                  v-model="item.value2"
                  class="w-full"
                />
              </div>
              <div class="vx-col md:w-1/2 w-half">
                <vs-button
                  color="danger"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="alterParameter('remove', index)"
                  >Remove Parameter</vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="vx-col md:w-2/3 w-half"
            v-if="
              item.idx != null &&
              item.idx[0] != null &&
              parameterOptions[item.idx[0]].parameterGroup == 'Time Range'
            "
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-half">
                Start Time (Hour only,minutes ignored):
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="item.value"
                  placeholder="Choose Start Time"
                />
              </div>
              <div class="vx-col md:w-1/3 w-half">
                End Time (Hour only,minutes ignored):
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="item.value2"
                  placeholder="Choose End Time"
                />
              </div>
              <div class="vx-col md:w-1/3 w-half">
                <vs-button
                  color="danger"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="alterParameter('remove', index)"
                  >Remove Parameter</vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="vx-col md:w-2/3 w-half"
            v-if="
              item.idx != null &&
              item.idx[0] != null &&
              parameterOptions[item.idx[0]].parameterGroup == 'Days Selection'
            "
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-half">
                <ejs-multiselect
                  showSelectAll="false"
                  id="multiselect6"
                  :fields="parameterFieldsDays"
                  v-model="item.value"
                  :dataSource="parameterOptions[item.idx[0]].opts"
                  popupHeight="400px"
                  mode="CheckBox"
                  showClearButton="false"
                  enableGroupCheckBox="false"
                  showDropDownIcon="true"
                  allowFiltering="true"
                  filterType="contains"
                  filterBarPlaceholder="Search"
                  placeholder="Select Days"
                ></ejs-multiselect>
              </div>
              <div class="vx-col md:w-1/2 w-half">
                <vs-button
                  color="danger"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="alterParameter('remove', index)"
                  >Remove Parameter</vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="vx-col md:w-2/3 w-half"
            v-if="
              item.idx != null &&
              item.idx[0] != null &&
              parameterOptions[item.idx[0]].parameterGroup == 'Transmit Command'
            "
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-half">
                <ejs-multiselect
                  showSelectAll="false"
                  id="multiselect7"
                  :fields="parameterFieldsCommands"
                  v-model="item.value"
                  :dataSource="parameterOptions[item.idx[0]].opts"
                  popupHeight="400px"
                  mode="CheckBox"
                  showClearButton="false"
                  enableGroupCheckBox="false"
                  showDropDownIcon="true"
                  allowFiltering="true"
                  filterType="contains"
                  filterBarPlaceholder="Search"
                  placeholder="Select Command"
                ></ejs-multiselect>
              </div>
              <div class="vx-col md:w-1/2 w-half">
                <vs-button
                  color="danger"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="alterParameter('remove', index)"
                  >Remove Parameter</vs-button
                >
              </div>
            </div>
          </div>

          <br /><br />
        </div>
        <br />
      </div>

      <hr />
      <br />
      <b>Configuration</b> <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">Assign Units by Group</div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect
            :fields="parameterFieldsGroups"
            v-model="currentTemplate.groups"
            :dataSource="groupData"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Assign Units"
          ></ejs-multiselect>
        </div>
        <br />
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">Assign User</div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect
            :fields="parameterFieldsUsers"
            v-model="currentTemplate.users"
            :dataSource="userData"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Assign Users"
          ></ejs-multiselect>
        </div>
        <br />
      </div>
      <hr />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Notification Channels</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addContact('add')"
            >Add Channel</vs-button
          >
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="showChannels()"
            >Select from Existing Channels</vs-button
          >
        </div>
      </div>
      <br />
      <div v-if="showExistingChannels">
        <div class="vx-row">
          <div class="vx-col md:w-1/8 w-half">
            <b>Current Channels</b>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-2/3 w-full">
            <vs-table stripe :data="existingChannels" max-height="500">
              <template slot="thead">
                <vs-th width="5%">No.</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Detail</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>
                      <b>{{ indextr + 1 }}.</b></span
                    >
                  </vs-td>
                  <vs-td>
                    {{ tr.type }}
                  </vs-td>
                  <vs-td>
                    {{ tr.detail }}
                  </vs-td>
                  <vs-td>
                    {{ tr.remark }}
                  </vs-td>
                  <vs-td>
                    <vs-button
                      color="success"
                      type="border"
                      icon-pack="feather"
                      icon="icon-check"
                      @click="addContactExisting(indextr)"
                      >Add</vs-button
                    >
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col md:w-1/3 w-full"></div>
          <br />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-2/3 w-full">
          <vs-table stripe :data="currentTemplate.channels" max-height="500">
            <template slot="thead">
              <vs-th width="5%">No.</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Detail</vs-th>
              <vs-th>Remarks</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span
                  >
                </vs-td>
                <vs-td>
                  <v-select
                    placeholder="Select Type"
                    clearable="false"
                    :options="['Telegram', 'Email', 'SMS']"
                    v-model="currentTemplate.channels[indextr].type"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="currentTemplate.channels[indextr].detail"
                    label-placeholder="Details"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="currentTemplate.channels[indextr].remark"
                    label-placeholder="Remarks"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-button
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="removeContact(indextr)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <hr />
      <br />

      <vs-button
        v-if="mode == 'add'"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        @click="postData('add')"
        >Add New Event Subscription</vs-button
      >
      <br />
      <div v-if="mode == 'update'">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            Created Event: <b>{{ currentTemplate.create_time }}</b>
          </div>
          <div
            class="vx-col md:w-1/4 w-half"
            v-if="currentTemplate.update_time != null"
          >
            Last Updated : <b>{{ currentTemplate.update_time }}</b>
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-half">
            Sample Notification Title :
            <b>{{ currentTemplate.label + ' - ' + 'IGT-3374' }}</b>
          </div>
          <div class="vx-col md:w-2/3 w-half">
            Sample Notification Message :
            <b>{{ 'Time: 2023-09-01 12:30:00 | Loc: ' + 'My Office HQ' }}</b>
          </div>
        </div>
        <br /><br />
        <div
          class="vx-row"
          v-if="
            userInfo.userRole == 'Administrator' ||
            currentTemplate.createdBy == userInfo.uid ||
            userInfo.access.actions.includes('events-staff')
          "
        >
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-pen"
              @click="postData('update')"
              v-if="
                userInfo.userRole == 'Administrator' ||
                userInfo.access.actions.includes('events-update') ||
                userInfo.access.actions.includes('events-staff')
              "
              >Update Event Subscription</vs-button
            >
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"
              @click="postData('delete')"
              v-if="
                userInfo.userRole == 'Administrator' ||
                userInfo.access.actions.includes('events-delete') ||
                userInfo.access.actions.includes('events-staff')
              "
              >Delete Event Subscription</vs-button
            >
          </div>
        </div>
      </div>

      <br />
    </vs-popup>

    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-half">
        <vs-button
          size="small"
          @click="addTemplate"
          v-if="
            userInfo.userRole == 'Administrator' ||
            userInfo.access.actions.includes('events-add') ||
            userInfo.access.actions.includes('events-staff')
          "
          >Add New Event</vs-button
        >
      </div>

      <div class="vx-col md:w-2/3 w-half">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
            >{{ 'Notifications Priority:' }}
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3"
            ><b>{{ alertType }}</b>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
            <vs-switch
              color="success"
              v-model="alertBoolean"
              vs-icon-off="notifications_none"
              vs-icon-on="done"
            />
          </vs-col>
        </vs-row>
      </div>
    </div>
    <br />
    <ejs-grid
      :dataSource="templateData"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :allowTextWrap="true"
      height="60vh"
      gridLines="Both"
      :filterSettings="filterOptions"
      :allowPaging="true"
      :searchSettings="searchOptions"
      :toolbar="toolbarOptions"
      ref="userTemplateGrid"
      id="userTemplateGrid"
      :pageSettings="pageSettings"
      :showColumnChooser="true"
      :allowSorting="true"
      :allowMultiSorting="true"
      :allowFiltering="true"
    >
      <e-columns>
        <e-column
          field="no"
          headerText="No."
          textAlign="Left"
          width="100"
        ></e-column>
        <e-column field="label" headerText="Label" textAlign="Left"></e-column>
        <e-column
          field="remarks"
          headerText="Remarks"
          textAlign="Left"
        ></e-column>
        <e-column
          field="update_time"
          headerText="Updated"
          textAlign="Left"
          width="200"
        ></e-column>
        <e-column
          headerText="Manage"
          textAlign="Left"
          :template="cTemplate"
          width="120"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate5.vue';
import vSelect from 'vue-select';
import axios from '@/axios.js';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
    flatPickr,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      alertType: '',
      initial: true,
      alertBoolean: false,
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      isLoading: false,
      mode: 'add',
      showExistingChannels: false,
      existingChannels: [],
      popupActive: false,
      popupTitle: 'Add New Event',
      templateData: [],
      userData: [
        {
          userGroup: 'Default',
          name: `${
            JSON.parse(localStorage.getItem('userInfo')).displayName
          } | ${JSON.parse(localStorage.getItem('userInfo')).username}`,
          id: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
      groupData: [{ groupGroup: 'Default', name: 'All Units Assigned', id: 0 }],
      currentTemplate: null,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      searchOptions: {
        fields: ['name', 'unitId', 'model', 'cellular'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      cTemplate() {
        return { template: columntempVue };
      },
      parameterFields: {
        groupBy: 'parameterGroup',
        text: 'parameterName',
        value: 'parameterIdx',
      },
      parameterFieldsBoolean: { text: 'label', value: 'val' },
      parameterFieldsUsers: { groupBy: 'userGroup', text: 'name', value: 'id' },
      parameterFieldsGroups: {
        groupBy: 'groupGroup',
        text: 'name',
        value: 'id',
      },
      parameterFieldsVariable: { text: 'label', value: 'val' },
      parameterFieldsChannels: { text: 'label', value: 'val' },
      parameterFieldsLocation: { text: 'label', value: 'val' },
      parameterFieldsRelations: { text: 'label', value: 'val' },
      parameterFieldsDays: { text: 'label', value: 'val' },
      parameterFieldsCommands: { text: 'label', value: 'val' },
      parameterFieldsPOI: { text: 'name', value: 'id' },
      parameterOptions: [
        {
          parameterGroup: 'Boolean',
          parameterName: 'Ignition',
          parameterId: 'ignition',
          parameterIdx: 0,
          opts: [
            {
              val: 0,
              label: 'OFF',
            },
            {
              val: 1,
              label: 'ON',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Idling',
          parameterId: 'idling',
          parameterIdx: 1,
          opts: [
            {
              val: 0,
              label: 'OFF',
            },
            {
              val: 1,
              label: 'ON',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Backup Battery',
          parameterId: 'backupBattery',
          parameterIdx: 2,
          opts: [
            {
              val: 0,
              label: 'OFF',
            },
            {
              val: 1,
              label: 'ON',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'GPS Connectivity',
          parameterId: 'gpsConnected',
          parameterIdx: 3,
          opts: [
            {
              val: 0,
              label: 'DISCONNECTED',
            },
            {
              val: 1,
              label: 'CONNECTED',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Input 1',
          parameterId: 'i1',
          parameterIdx: 4,
          opts: [
            {
              val: 0,
              label: 'OFF',
            },
            {
              val: 1,
              label: 'ON',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Immobilizer',
          parameterId: 'immobilizer',
          parameterIdx: 5,
          opts: [
            {
              val: 0,
              label: 'OFF',
            },
            {
              val: 1,
              label: 'ON',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Speed',
          parameterId: 'speed',
          parameterIdx: 6,
          parameterPostFix: 'kph',
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Mileage',
          parameterId: 'mileage',
          parameterPostFix: 'km',
          parameterIdx: 7,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Voltage',
          parameterId: 'volt',
          parameterPostFix: 'V',
          parameterIdx: 8,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Heading',
          parameterId: 'heading',
          parameterPostFix: '°',
          parameterIdx: 9,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Fuel Tank 1',
          parameterId: 'fuel',
          parameterPostFix: '%',
          parameterIdx: 10,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Fuel Tank 2',
          parameterId: 'fuel2',
          parameterPostFix: '%',
          parameterIdx: 11,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Temperature Sensor 1',
          parameterId: 'temp',
          parameterPostFix: '°C',
          parameterIdx: 12,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Temperature Sensor 2',
          parameterId: 'temp2',
          parameterPostFix: '°C',
          parameterIdx: 13,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Temperature Sensor 3',
          parameterId: 'temp3',
          parameterPostFix: '°C',
          parameterIdx: 14,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Temperature Sensor 4',
          parameterId: 'temp4',
          parameterPostFix: '°C',
          parameterIdx: 15,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Location',
          parameterName: 'Place of Interest',
          parameterId: 'poi',
          parameterIdx: 16,
          opts: [
            {
              val: 'entry',
              label: 'Entry',
            },
            {
              val: 'exit',
              label: 'Exit',
            },
            {
              val: 'proximity',
              label: 'Proximity (within 500meters)',
            },
          ],
        },
        {
          parameterGroup: 'Elapsed Time',
          parameterName: 'Minimum Duration',
          parameterId: 'duration',
          parameterIdx: 17,
          opts: [],
        },
        {
          parameterGroup: 'Time Range',
          parameterName: 'Start - End Hour',
          parameterId: 'hourRange',
          parameterIdx: 18,
          opts: [],
        },
        {
          parameterGroup: 'Days Selection',
          parameterName: 'Days Enabled',
          parameterId: 'days',
          parameterIdx: 19,
          opts: [
            {
              val: 'Mon',
              label: 'Monday',
            },
            {
              val: 'Tue',
              label: 'Tuesday',
            },
            {
              val: 'Wed',
              label: 'Wednesday',
            },
            {
              val: 'Thu',
              label: 'Thursday',
            },
            {
              val: 'Fri',
              label: 'Friday',
            },
            {
              val: 'Sat',
              label: 'Saturday',
            },
            {
              val: 'Sun',
              label: 'Sunday',
            },
          ],
        },
        {
          parameterGroup: 'Transmit Command',
          parameterName: 'Commands',
          parameterId: 'command',
          parameterIdx: 20,
          opts: [
            {
              val: 'immobilizerOn',
              label: 'On Immobilizer',
            },
            {
              val: 'immobilizerOff',
              label: 'Off Immo',
            },
            {
              val: 'outputOn',
              label: 'On Buzzer',
            },
            {
              val: 'outputOff',
              label: 'Off Buzzer',
            },
            {
              val: 'restart',
              label: 'Restart',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Battery',
          parameterId: 'batt',
          parameterPostFix: '%',
          parameterIdx: 21,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Watch Steps Count',
          parameterId: 'steps',
          parameterPostFix: '',
          parameterIdx: 22,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Watch Low Blood Pressure',
          parameterId: 'lowPressure',
          parameterPostFix: 'mm',
          parameterIdx: 23,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Watch High Blood Pressure',
          parameterId: 'highPressure',
          parameterPostFix: 'Hg',
          parameterIdx: 24,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Watch Heart Rate',
          parameterId: 'heartRate',
          parameterPostFix: 'Beats per minute',
          parameterIdx: 25,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Watch SPO2 Oxygen Rate',
          parameterId: 'spO2',
          parameterPostFix: '%',
          parameterIdx: 26,
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch Wearing',
          parameterId: 'wearStatus',
          parameterIdx: 27,
          opts: [
            {
              val: 0,
              label: 'Wearing',
            },
            {
              val: 1,
              label: 'Take Off',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch Low Power Mode',
          parameterId: 'lowPowerMode',
          parameterIdx: 28,
          opts: [
            {
              val: 0,
              label: 'ON',
            },
            {
              val: 1,
              label: 'OFF',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch Idle',
          parameterId: 'watchIdle',
          parameterIdx: 29,
          opts: [
            {
              val: 0,
              label: 'ON',
            },
            {
              val: 1,
              label: 'OFF',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch SOS Alert',
          parameterId: 'sos',
          parameterIdx: 30,
          opts: [
            {
              val: 0,
              label: 'ON',
            },
            {
              val: 1,
              label: 'OFF',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch Battery Alert',
          parameterId: 'lowBatteryAlarm',
          parameterIdx: 31,
          opts: [
            {
              val: 0,
              label: 'ON',
            },
            {
              val: 1,
              label: 'OFF',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch Removal Alert',
          parameterId: 'removalAlarm',
          parameterIdx: 32,
          opts: [
            {
              val: 0,
              label: 'ON',
            },
            {
              val: 1,
              label: 'OFF',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch Fall Detection',
          parameterId: 'fallAlarm',
          parameterIdx: 33,
          opts: [
            {
              val: 0,
              label: 'ON',
            },
            {
              val: 1,
              label: 'OFF',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Watch Abnormal Heart Rate',
          parameterId: 'abnormalHeartAlarm',
          parameterIdx: 34,
          opts: [
            {
              val: 0,
              label: 'ON',
            },
            {
              val: 1,
              label: 'OFF',
            },
          ],
        },
        // {
        //   parameterGroup: 'Elapsed Time',
        //   parameterName: 'Minumum Duration (Repeat)',
        //   parameterId: 'duration',
        //   parameterIdx: 35,
        //   opts: [],
        // },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Input 2',
          parameterId: 'i2',
          parameterIdx: 36,
          opts: [
            {
              val: 0,
              label: 'OFF',
            },
            {
              val: 1,
              label: 'ON',
            },
          ],
        },
        {
          parameterGroup: 'Boolean',
          parameterName: 'Input 3',
          parameterId: 'i3',
          parameterIdx: 37,
          opts: [
            {
              val: 0,
              label: 'OFF',
            },
            {
              val: 1,
              label: 'ON',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Humidity Sensor 1',
          parameterId: 'humidity',
          parameterIdx: 38,
          parameterPostFix: '%',
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Humidity Sensor 2',
          parameterId: 'humidity2',
          parameterIdx: 39,
          parameterPostFix: '%',
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Humidity Sensor 3',
          parameterId: 'humidity3',
          parameterIdx: 40,
          parameterPostFix: '%',
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
        {
          parameterGroup: 'Variable',
          parameterName: 'Humidity Sensor 4',
          parameterId: 'humidity4',
          parameterIdx: 41,
          parameterPostFix: '%',
          opts: [
            {
              val: '<',
              label: '< Less than',
            },
            {
              val: '==',
              label: '= Equal to',
            },
            {
              val: '>',
              label: '> More than',
            },
          ],
        },
      ],
      parameterOptionsRelations: [
        {
          val: '&&',
          label: 'AND',
        },
        {
          val: '||',
          label: 'OR',
        },
        {
          val: 'THEN',
          label: 'THEN',
        },
      ],
      parameterOptionsChannels: [
        {
          val: 'Telegram',
          label: 'Telegram',
        },
        {
          val: 'Email',
          label: 'Email',
        },
        {
          val: 'SMS',
          label: 'SMS *Currently not available',
        },
      ],
      configdateTimePicker: {
        enableTime: true,
        enableMinutes: false,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
    };
  },
  computed: {},
  methods: {
    showChannels() {
      this.showExistingChannels = !this.showExistingChannels;
    },
    removeContact(index) {
      this.currentTemplate.channels.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Channel',
        color: 'success',
      });
    },
    addContact() {
      this.currentTemplate.channels.push({ type: '', detail: '', remark: '' });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty Channel',
        color: 'success',
      });
    },
    addContactExisting(index) {
      this.currentTemplate.channels.push({
        type: this.existingChannels[index].type,
        detail: this.existingChannels[index].detail,
        remark: this.existingChannels[index].remark,
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Existing Channel',
        color: 'success',
      });
    },
    alterParameter(type, idx) {
      const self = this;
      if (self.currentTemplate != null) {
        if (type == 'add') {
          if (self.currentTemplate.parameters.length == 0) {
            self.currentTemplate.parameters.push({
              idx: [],
              value: [],
              value2: [],
            });
          } else if (self.currentTemplate.parameters.length != 0) {
            self.currentTemplate.parameters.push({
              idx: [],
              value: [],
              value2: [],
              relation: [],
            });
          }
          this.$vs.notify({
            time: 4000,
            text: 'Added Event Parameter',
            color: 'success',
          });
        } else if (type == 'remove') {
          self.currentTemplate.parameters.splice(idx, 1);
          this.$vs.notify({
            time: 4000,
            text: 'Removed Parameter',
            color: 'warning',
          });
        }
      }
    },
    validateTemplate() {
      const self = this;

      return new Promise((resolve, reject) => {
        if (self.currentTemplate.label.length < 5) {
          reject('Label field is mandatory. Minimum 5 characters.');
        }
        if (self.currentTemplate.parameters.length < 1) {
          reject('Parameter adding is mandatory. Minimum 1 set of parameter.');
        }
        if (self.currentTemplate.users.length < 1) {
          reject('User assignment is mandatory. Minimum 1 user.');
        }
        if (self.currentTemplate.groups.length < 1) {
          reject('Unit assignment is mandatory. Minimum 1 group of units.');
        }
        self.currentTemplate.parameters.forEach(function (element, index) {
          if (element.idx.length == 0) {
            reject('Parameter - Type cannot be empty');
          }
          if (index == 0) {
            if (element.idx[0] == 17 || element.idx[0] == 20) {
              reject(
                `First parameter cannot be from ${
                  self.parameterOptions[element.idx[0]].parameterGroup
                }`,
              );
            }
          }
          if (index != 0) {
            if (element.relation.length == 0) {
              reject('Parameter Relation cannot be empty');
            }
          }
        });
        resolve(true);
      });
    },
    addTemplate() {
      const self = this;
      self.mode = 'add';
      self.popupTitle = 'Add New Event';
      self.currentTemplate = {
        label: '',
        remarks: '',
        type: 'Self Created',
        createdBy: self.userInfo.uid,
        parameters: [],
        users: [],
        groups: [],
        channels: [],
      };
      self.popupActive = true;
    },
    editTemplate(data) {
      const self = this;
      self.mode = 'update';
      self.popupTitle = `Update Event ${data.label}`;
      self.currentTemplate = {
        label: data.label,
        remarks: data.remarks,
        type: data.type,
        createdBy: data.createdBy,
        parameters: JSON.parse(data.parameters),
        users: JSON.parse(data.users),
        groups: JSON.parse(data.groups),
        channels: JSON.parse(data.channels),
        id: data.id,
        create_time: data.create_time,
        update_time: data.update_time,
      };
      self.popupActive = true;
    },
    getData() {
      const self = this;
      let staffAccess;
      axios
        .post(
          `https://api.igeotechgps.com/api-events/get-events/${self.userInfo.uid}/${self.userInfo.userRole}`,
          {
            adtlAccess: self.userInfo.access.actions.includes('events-staff'),
          },
        )
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.templateData = response.data.templateData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getData2() {
      const self = this;
      let uid = self.userInfo.uid;
      if (self.userInfo.access.actions.includes('events-staff')) {
        uid = 1;
      }
      self.$http
        .get(`admin/users/main/${uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            response.data.userData.forEach(function (element) {
              self.userData.push({
                id: element.id,
                name: element.username,
                userGroup: 'User Created',
              });
            });
            response.data.groupData.forEach(function (element) {
              self.groupData.push({
                id: element.id,
                name: element.name,
                groupGroup: 'User Created',
              });
            });
            axios
              .post('https://api.igeotechgps.com/api-events/get-channels', {
                userIds: self.userData,
              })
              .then(function (response) {
                if (response.status == 200 && response.data.success) {
                  self.existingChannels = response.data.existingChannels;
                } else if (response.data.error) {
                } else {
                }
              });
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    postData(type) {
      const self = this;
      let url;
      let successText;
      let successTitle;
      let failureText;
      if (type == 'add') {
        url = 'https://api.igeotechgps.com/api-events/add-events';
        successText =
          'Note: Newly added events could take upto 2 hours to activate';
        successTitle = 'Added New Event';
        failureText =
          'Could not add event, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
      }
      if (type == 'update') {
        url = 'https://api.igeotechgps.com/api-events/update-events';
        successText =
          'Note: Updated events configurations could take upto 2 hours to activate';
        successTitle = 'Updated Event';
        failureText =
          'Could not update event, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
      }
      if (type == 'delete') {
        url = 'https://api.igeotechgps.com/api-events/delete-events';
        successText =
          'Note: Deleted events could take upto 2 hours to de-activate';
        successTitle = 'Deleted Event';
        failureText =
          'Could not delete event, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
        const text =
          'Event deletion action is PERMANENT & IRREVERSIBLE. Continue? ';
        if (confirm(text) == false) {
          return;
        }
      }

      if (type == 'add' || type == 'update') {
        self
          .validateTemplate()
          .then((result) => {
            self.confirmPostData(url, successText, successTitle, failureText);
          })
          .catch((error) => {
            self.$vs.notify({
              time: 5000,
              title: error,
              color: 'warning',
            });
          });
      } else {
        self.confirmPostData(url, successText, successTitle, failureText);
      }
    },
    confirmPostData(url, successText, successTitle, failureText) {
      const self = this;
      axios
        .post(url, {
          userInfo: self.userInfo,
          currentTemplate: self.currentTemplate,
        })
        .then(function (response) {
          self.popupActive = false;
          if (response.status == 200 && response.data.success) {
            self.$vs.notify({
              time: 10000,
              text: successText,
              title: successTitle,
              color: 'success',
            });
            self.getData();
            self.getData2();
          } else {
            self.$vs.notify({
              time: 8000,
              title: failureText,
              color: 'warning',
            });
            if (response.data.error) {
            } else {
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toolbarClick(args) {
      if (args.item.id === 'userTemplateGrid_excelexport') {
        var exportProperties = {
          fileName: 'Event Templates - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.userTemplateGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'userTemplateGrid_pdfexport') {
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Event Templates - Listing.pdf',
        };
        this.$refs.userTemplateGrid.pdfExport(exportProperties);
      }
    },
  },
  watch: {
    alertBoolean: {
      handler(val) {
        const self = this;
        if (self.initial == false) {
          localStorage.setItem('alert-priority', self.alertBoolean);
          self.alertType =
            self.alertBoolean == true
              ? 'High Priority (Sound + Popup)'
              : 'Low Priority';
        }
      },
    },
  },
  mounted() {
    const self = this;
    this.getData();
    this.getData2();
    if (
      localStorage.getItem('alert-priority') == true ||
      localStorage.getItem('alert-priority') == 'true'
    ) {
      self.alertBoolean = true;
    }
    self.alertType =
      self.alertBoolean == true
        ? 'High Priority (Sound + Popup)'
        : 'Low Priority';

    self.initial = false;
  },
};
</script>
